<template>
  <div class="wx-compare">
      <NavHeader></NavHeader>
      <div class="routerSwitch">
        <router-view />
      </div>
  </div>
</template>

<script setup>
import NavHeader from '../../components/navheader/index.vue'

</script>

<style lang="less" scoped>
.wx-compare{
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  .routerSwitch{
    flex: 1;
    background: #1A1A1A;
    overflow: auto;
  }
}
</style>
